import React from 'react';
import request from 'arcdynamic-request';
import {Autocomplete} from "@material-ui/lab";
import {TextField} from "@material-ui/core";

export default class SelectTeam extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			items: false,
		};
	}

	componentDidMount() {
		request(arc.path.api, {
			service: 'arcimedes',
			action: 'open.datasource.table.Data.getData',
			params: ['code', 'TEAM', {
				limit: {
					count: 1000,
					offset: 0,
				},
				column: [
					'ARCIMEDES_ROW_ID',
					'FIRST_NAME',
					'LAST_NAME',
					'DELETED',
				],
				filter: [
					{
						code: 'FIRST_NAME',
						text: '',
						type: 'notNull',
					},
					{
						code: 'LAST_NAME',
						text: '',
						type: 'notNull',
					},
				],
				filterType: 'and',
				order: [
					{
						code: 'FIRST_NAME',
						type: 'asc',
					},
					{
						code: 'LAST_NAME',
						type: 'asc',
					},
				],
			}],
		}).then(res => {
			let items = res.data ? res.data.filter(x => x.FIRST_NAME && x.LAST_NAME) : false;
			this.setState({items});
		});
	}

	render() {
		const { items } = this.state;
		const inactive = items && items.filter(x => x.DELETED === 'y') || [];
		const active = items && items.filter(x => x.DELETED !== 'y') || [];
		let itemsSorted = [...active, ...inactive];

		itemsSorted = itemsSorted.map((el) => {
			el.groupedBy = el.DELETED !== 'y' ? 'active' : 'inactive';
			return el
		});

		return (
			<Autocomplete
				className={this.props.theme}
				fullWidth	style={{marginBottom: '10px'}} disabled={!items || this.props.disabled}
				getOptionLabel={(option) => {
					let result = '';
					if (option && option.length !== 0) {
						result = option.FIRST_NAME + ' ' + option.LAST_NAME;
					}
					return result;
				}}
				options={itemsSorted}
				groupBy={(option) => option.groupedBy}
				value={this.props.getValue(this.props.value, items, 'ARCIMEDES_ROW_ID', 'single')}
				renderInput={(params) => <TextField {...params} label={this.props.label} variant="outlined" />}
				onChange={(event, reason) => {this.props.onChange(event, reason, this.props.name, 'single', 'ARCIMEDES_ROW_ID')}}
			/>
		);
	}
}
